import async from 'lib/load/async-component'

export default {
  // homepage
  homepage: async('Homepage', () => import(/* webpackChunkName: "homepage" */ './homepage')),

  // registration
  registrationLogin: async('RegistrationLogin', () =>
    import(/* webpackChunkName: "registration" */ './registration/login')
  ),
  registrationSignup: async('RegistrationSignup', () =>
    import(/* webpackChunkName: "registration" */ './registration/signup')
  ),

  // inbox
  inboxInbox: async('InboxInbox', () => import(/* webpackChunkName: "inbox" */ './inbox/inbox')),
  inboxThread: async('InboxThread', () => import(/* webpackChunkName: "inbox" */ './inbox/thread')),

  // cart
  cart: async('Cart', () => import(/* webpackChunkName: "cart" */ './cart')),

  // account
  accountAgenda: async('AccountAgenda', () => import(/* webpackChunkName: "account" */ './account/agenda')),
  accountDispute: async('AccountDispute', () => import(/* webpackChunkName: "account" */ './account/dispute')),
  accountOrders: async('AccountOrders', () => import(/* webpackChunkName: "account" */ './account/orders')),
  accountPayouts: async('AccountPayouts', () => import(/* webpackChunkName: "account" */ './account/payouts')),
  accountPayoutDetails: async('AccountPayoutDetails', () =>
    import(/* webpackChunkName: "account" */ './account/payout-details')
  ),
  accountRefill: async('AccountRefill', () => import(/* webpackChunkName: "account" */ './account/refill')),
  accountStats: async('AccountStats', () => import(/* webpackChunkName: "account" */ './account/stats')),

  // book
  bookingInitial: async('bookingInitial', () => import(/* webpackChunkName: "book" */ './booking/initial')),

  // booking
  bookingDetails: async('BookingDetails', () => import(/* webpackChunkName: "booking" */ './booking/details')),
  bookingPrice: async('BookingPrice', () => import(/* webpackChunkName: "booking" */ './booking/price')),

  // course
  courseShow: async('Course', () => import(/* webpackChunkName: "course" */ './course/show')),

  // course
  courseList: async('CourseList', () => import(/* webpackChunkName: "courses" */ './course/list')),
  courseEdit: async('CourseEdit', () => import(/* webpackChunkName: "courses" */ './course/edit')),
  courseTranslate: async('CourseTranslate', () => import(/* webpackChunkName: "courses" */ './course/translate')),
  courseSuspend: async('CourseSuspend', () => import(/* webpackChunkName: "courses" */ './course/suspend')),
  courseBoost: async('CourseBoost', () => import(/* webpackChunkName: "courses" */ './course/boost')),
  courseRedeem: async('CourseRedeem', () => import(/* webpackChunkName: "courses" */ './course/redeem')),

  // invite
  pagesInvite: async('PagesInvite', () => import(/* webpackChunkName: "invite" */ './pages/invite')),

  // hydrate
  pagesHydrate: async('PagesHydrate', () => import(/* webpackChunkName: "hydrate" */ './pages/hydrate')),

  // gift card
  pagesGift: async('GiftCard', () => import(/* webpackChunkName: "gift" */ './pages/gift')),

  // new tutoring campaign `beta`
  campaignsRecruitment: async('Recruitment', () =>
    import(/* webpackChunkName: "recruitment" */ './campaigns/recruitment')
  ),

  // request
  pagesRequest: async('PagesRequest', () => import(/* webpackChunkName: "request" */ './pages/request')),

  // reviews
  reviews: async('Reviews', () => import(/* webpackChunkName: "reviews" */ './pages/reviews')),

  // profile
  profileAccount: async('ProfileAccount', () => import(/* webpackChunkName: "profile" */ './profile/account')),
  notifications: async('Notifications', () =>
    import(/* webpackChunkName: "profile" */ './profile/account/notifications')
  ),
  closeAccount: async('Other', () => import(/* webpackChunkName: "profile" */ './profile/account/other')),
  payments: async('Payments', () => import(/* webpackChunkName: "profile" */ './profile/account/payments')),
  account: async('Account', () => import(/* webpackChunkName: "profile" */ './profile/account/account')),
  invoices: async('Invoices', () => import(/* webpackChunkName: "profile" */ './profile/account/invoices')),
  profileProfile: async('ProfileProfile', () => import(/* webpackChunkName: "profile" */ './profile/profile')),
  profileVerifications: async('ProfileVerifications', () =>
    import(/* webpackChunkName: "profile" */ './profile/verifications')
  ),
  profileDashboard: async('ProfileDashboard', () => import(/* webpackChunkName: "profile" */ './profile/dashboard')),

  // review
  reviewClass: async('ReviewClass', () => import(/* webpackChunkName: "review" */ './profile/review')),

  // public profile
  profilePublic: async('ProfilePublic', () => import(/* webpackChunkName: "public" */ './profile/public')),

  // confirm email popup
  popupsConfirm: async('PopupsConfirm', () => import(/* webpackChunkName: "popups" */ './popups/confirm')),

  // phone popup
  popupsPhone: async('PopupsPhone', () => import(/* webpackChunkName: "popups" */ './popups/phone')),

  // message
  popupsMessage: async('PopupsMessage', () => import(/* webpackChunkName: "message" */ './popups/message')),

  // faqs
  faqs: async('Faqs', () => import(/* webpackChunkName: "faqs" */ './faqs')),

  // how
  how: async('How', () => import(/* webpackChunkName: "how" */ './how')),

  // search
  search: async('Search', () => import(/* webpackChunkName: "search" */ './search')),

  // header
  header: async('Header', () => import(/* webpackChunkName: "header" */ './header')),

  // footer
  footer: async('Footer', () => import(/* webpackChunkName: "footer" */ './footer'))
}
